import React from "react";
import { motion } from "framer-motion";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import ContactForm from "../components/ContactForm";
import { useLanguage } from "../context/LanguageContext";

const Contact = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-white text-gray-900">
      <section className="relative w-full min-h-screen flex items-center justify-center text-white">
        <div className="absolute inset-0">
          <img src="/assets/images/contact/contact.jpg" alt={t("common.contactHeroAlt")} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        <div className="relative z-10 container mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 bg-white bg-opacity-90 p-8 rounded-xl shadow-lg border border-gray-300 max-w-5xl">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6 text-gray-900"
          >
            <h2 className="text-5xl font-bold text-yellow-600">{t("contactPage.heading")}</h2>
            <p className="text-lg text-gray-700">{t("contactPage.subtitle")}</p>

            <div className="flex items-center space-x-4">
              <FaPhoneAlt className="text-yellow-600 text-3xl" />
              <a href="tel:+11234567890" className="text-lg text-gray-800 hover:text-yellow-500 transition">
                +1 (647) 906-7308
              </a>
            </div>

            <div className="flex items-center space-x-4">
              <FaEnvelope className="text-yellow-600 text-3xl" />
              <a href="mailto:info@ir-accounting.ca" className="text-lg text-gray-800 hover:text-yellow-500 transition">
                info@ir-accounting.ca
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <ContactForm />
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
